import { GetStaticPropsContext, GetStaticPropsResult } from "next";
import { useRouter } from "next/router";
import { SSRConfig } from "next-i18next";

import MDXPageEN from "@components/blog/blog_en";
import MDXPagePL from "@components/blog/blog_pl";
import {
  BlogContext,
  BlogContextInterface,
  BlogInterfaceData,
} from "@context/BlogContext";
import { baseStaticProps } from "@lib/baseStaticProps";
import { getPosts } from "@lib/blog";

interface StaticProps {
  allPosts: BlogInterfaceData[];
}

export const getStaticProps = async ({
  locale,
}: GetStaticPropsContext): Promise<
  GetStaticPropsResult<StaticProps | SSRConfig>
> => {
  const resolvedLocale = locale ?? "en";

  return {
    props: {
      allPosts: BlogContextInterface.postsToBlogInterfaceData(
        await getPosts(),
        resolvedLocale,
      ),
      ...(await baseStaticProps({ locale })),
    },
  };
};

const ThemedPage = () => {
  const { locale } = useRouter();

  return <>{locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}</>;
};

export default function Blog({ allPosts }: StaticProps) {
  return (
    <BlogContext.Provider value={new BlogContextInterface(allPosts)}>
      <ThemedPage />
    </BlogContext.Provider>
  );
}
